import { jsxs, jsx } from "react/jsx-runtime";
const IconLinkSvg = ({ title, titleId, ...props }) => /* @__PURE__ */ jsxs(
  "svg",
  {
    width: 16,
    height: 16,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    fill: "currentColor",
    "aria-labelledby": titleId,
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ jsx("path", { d: "M10.706 14.445a5.182 5.182 0 0 1-1.23-.167l-1.61 1.61a2.656 2.656 0 0 1-4.335-2.895c.134-.322.33-.615.578-.862l2.467-2.467a2.673 2.673 0 0 1 3.757 0 .834.834 0 0 0 1.179-1.179 4.337 4.337 0 0 0-5.693-.343 4.2 4.2 0 0 0-.421.343L2.93 10.953a4.323 4.323 0 0 0 6.114 6.114l2.744-2.745a5.18 5.18 0 0 1-1.082.123Z" }),
      /* @__PURE__ */ jsx("path", { d: "M9.291 5.553c.416.006.829.062 1.23.167l1.61-1.61a2.657 2.657 0 1 1 3.758 3.757l-2.468 2.467a2.673 2.673 0 0 1-3.757 0 .833.833 0 0 0-1.178 1.179 4.337 4.337 0 0 0 5.693.344c.147-.106.288-.22.42-.344l2.468-2.468a4.324 4.324 0 0 0-6.114-6.114L8.21 5.676a5.18 5.18 0 0 1 1.082-.123Z" })
    ]
  }
);
export {
  IconLinkSvg
};
